var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0732 2.84161H17.9525L17.808 1.904C17.6467 0.856811 16.6476 0 15.588 0H7.83367C6.77404 0 5.77493 0.856811 5.61374 1.904L5.46919 2.84161H4.91969C3.86016 2.84161 2.99316 3.7086 2.99316 4.76813V25.4773C2.99316 26.5369 3.86016 27.4038 4.91969 27.4038H34.0731C35.1326 27.4038 35.9997 26.5369 35.9997 25.4773V4.76823C35.9999 3.7086 35.1327 2.84161 34.0732 2.84161Z",
    fill: "#FFA400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6776 4.91797H4.7793V24.5057H33.6776V4.91797Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0308 8.934C32.8625 7.88779 31.8579 7.03186 30.7984 7.03186H1.64492C0.585293 7.03186 -0.144108 7.88779 0.0241404 8.934L2.68771 25.5018C2.85595 26.548 3.86054 27.404 4.92007 27.404H34.0735C35.133 27.404 35.8624 26.548 35.6943 25.5018L33.0308 8.934Z",
    fill: "#F6C65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.3bdc376b4a38587013f40899a7a55da9.svg";
export { ForwardRef as ReactComponent };